
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke122aRequest, Sgke122aResponse, Sgke122aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke122aService {

  /** 検索フォーム情報(画面戻り用) */
  public searchFormValue: Sgke122aRequest;
  /** 画面モード区分(画面戻り用) */
  public mode: String;

  /**
   * コンストラクタ
   * @param {Sgke122aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke122aService
   */
  constructor(
    public service: Sgke122aService,
    public apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE122A_入金突合検索API呼び出し
   * @param {Sgke122aRequest} request 
   * @returns {Observable<Sgke122aResponse>}
   * @memberof UsedSgke122aService
   */
  public doSgke122a(request: Sgke122aRequest): Observable<Sgke122aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.sgke122aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE122A');
          return throwError(err.message);
        })
      );
  }

}
